import Vue from 'vue'
import App from './App.vue'
import axios from "axios";
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import VueKeycloak from '@dsb-norge/vue-keycloak-js'
import VueFilterDateFormat from 'vue-filter-date-format';
import Vuelidate from 'vuelidate'
// import './assets/scss/print.scss';
import PrivacyPolicy from './components/PrivacyPolicy';
Vue.component('PrivacyPolicy', PrivacyPolicy);

import PreLoading from './components/loading';
Vue.component('PreLoading', PreLoading);

import LoginTimeOut from './components/LoginTimeOut';
Vue.component('LoginTimeOut', LoginTimeOut);

Vue.config.productionTip = false

Vue.use(CoreuiVue)
Vue.use(VueFilterDateFormat)
Vue.use(Vuelidate)
Vue.prototype.$log = console.log.bind(console)

import Print from 'vue-print-plugin';
Vue.use(Print);

Vue.use(VueKeycloak, {
  // logout: {
  //   redirectUri: 'https://google.com'
  // },
  init: {
    // Use 'login-required' to always require authentication
    // If using 'login-required', there is no need for the router guards in router.js
    onLoad: 'check-sso'
  },
  config: {
    url: 'https://auth.liberty-resort.net/auth',
    clientId: 'kunousan-spring-boot-app',
    realm: 'Liberty',
    // logoutRedirectUri: this.$router.push(),
  },
  onReady: (keycloak) => {
    const pageLoad =
    new Vue({
      data: { loading: false },
      router,
      store,
      icons,
      keycloak,
      render: h => h(App)
    }).$mount('#app')
    
    router.beforeEach((to, from, next) => {
      pageLoad.loading = true
        next()
    })
    
    router.afterEach(() => {
      pageLoad.loading = false
    })

  },
  onInitError: error => {
    console.log('erreur init :', error)
    // alert('error')
    // reject('error', error)
  }, 
})

/** 
 * Make spinner by axios response
 */

//**Axios request interceptor */
axios.interceptors.request.use(function (config) {
  store.commit("SessionReload") //vuex mutation set loading state to true
  return config;
  }, 
  function (error) {
    if (error.response.status == 401){
      store.commit("SessionOut")
      }
    return Promise.reject(error);
});

//**Axios response  interceptor */
axios.interceptors.response.use(function (config) {
  // if(config.status == 401)
  // store.commit("SessionOut"); //vuex mutation set loading state to false
  return config;
  }, 
  function (error) {
  if (error.response.status == 401){
    store.commit("SessionOut")
    } //vuex mutation set loading state to false
    return Promise.reject(error);
});


// ===============↓↓↓ filter ↓↓↓=============
// word limit 
Vue.filter('wordLimit', function (text, length, suffix) {
  if (text.length > length) {
      return text.substring(0, length) + suffix;
  } else {
      return text;
  }
});

// date formate 
import moment from 'moment'
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY年MM月DD日')
  }
});

Vue.filter('formatTime', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY年MM月DD日 HH:MM')
  }
});

// status Code 
Vue.filter('statusName', function (value) {
  var statusText;
  switch (value) {
    case 0:
      statusText = "無効";
      break;
    case 1:
      statusText = "掲載準備";
      break;
    case 10:
        statusText = "掲載中";
        break;
    case 15:
      statusText = "掲載一時停止";
      break;
    case 20:
      statusText = "掲載終了";
      break;
    case 30:
      statusText = "割引プラン";
      break;
    case 99:
      statusText = "終了";
      break;
    case 100:
      statusText = "廃棄";
      break;
  }
  return statusText;
  
});

// Member status 
// status Code 
Vue.filter('MemberStatus', function (value) {
  var statusText;
  switch (value) {
    case 99:
      statusText = "更新済み";
      break;
    case 98:
      statusText = "事前登録";
      break;
    case 1:
        statusText = "Keycloakから同期化";
        break;
    case 2:
      statusText = "WEB登録";
      break;
    case 0:
      statusText = "無効";
      break;
  }
  return statusText;
  
});

// coupon status 
Vue.filter('CouponStatus', function (value) {
  var statusText;
  switch (value) {
    case 0:
      statusText = "無効";
      break;
    case 1:
      statusText = "有効";
      break;
    case 99:
        statusText = "使用済み";
        break;
    case 100:
      statusText = "期間切れ";
      break;
  }
  return statusText;
  
});

// couponOptionTypeName
Vue.filter('couponOptionTypeName', function(value) {
  switch (value) {
    case 1:
      return "割引率";
    case 2: 
      return "割引金額";
  }
})

// CounponOptionValue
Vue.filter('couponOptionValue', function(value, type) {
  switch (type) {
    case 1:
      // 割引率
      return `${value}%`;
    case 2:
      // 割引金額 
      return `${value}円`;
  }
})